import { COOKIE_ORDER_NUMBER_KEY } from '@yme/common/constants';
import { COOKIE_CART_ID_KEY, PAYMENT_LINK_PROVIDER } from '@yme/common/redux/cart/constants';
export var MODALS;
(function (MODALS) {
    MODALS["CONFIGURATOR_MODAL"] = "configuratorModal";
    MODALS["SHOPPING_CART_ERROR"] = "shoppingCartError";
    MODALS["CONFIRMATION_DELETING_MODAL"] = "confirmationDeletingModal";
    MODALS["GENERAL_MESSAGE_MODAL"] = "generalMessageModal";
    MODALS["CHECKOUT_REVIEW_MODAL"] = "checkoutReviewModal";
    MODALS["MAP_MODAL"] = "mapModal";
    MODALS["MAP_MODAL_NEW"] = "mapModalNew";
    MODALS["RESET_SESSION_MODAL"] = "resetSessionModal";
    MODALS["SHARE_CART_BY_QR_MODAL"] = "shareCartByQrModal";
    MODALS["ANOTHER_SESSION_MODAL"] = "anotherSessionModal";
    MODALS["SHARE_CART_BY_EMAIL_MODAL"] = "shareCartByEmailModal";
    MODALS["GENERATE_QR_ERROR_MODAL"] = "generateQrErrorModal";
    MODALS["SELECT_YOUR_MODEL_MODAL"] = "selectYourModelModal";
    MODALS["PROCEED_TO_CART_MODAL"] = "proceedToCartModal";
    MODALS["LOGIN_REQUIRED_MODAL"] = "loginRequiredModal";
    MODALS["REQUIRED_PART_VARIANT_MODAL"] = "requiredPartVariantModal";
    MODALS["RESET_MODEL_MODAL"] = "resetModelModal";
    MODALS["ALERT_MESSAGE_MODAL"] = "alertMessageModal";
    MODALS["REDIRECTION_EXTERNAL_CART_MODAL"] = "redirectionExternalCartModal";
    MODALS["COMPARISON_REMOVE_MODEL_MODAL"] = "comparisonRemoveModelModal";
    MODALS["FLIP_TO_LANDSCAPE_MODAL"] = "flipToLandscapeModal";
    MODALS["REQUIRED_PARTS_INFO_MODAL"] = "requiredPartsInfoModal";
    MODALS["NEWSLETTER_MODAL"] = "newsletterModal";
    MODALS["REDEMPTION_CODE_MODAL"] = "redemptionCodeModal";
    MODALS["TERMINAL_PAYMENT_MODAL"] = "terminalPaymentModal";
    MODALS["TERMINAL_WRONG_ORDER_MODAL"] = "terminalWrongOrderModal";
})(MODALS || (MODALS = {}));
export var ModalState;
(function (ModalState) {
    ModalState["ERROR"] = "error";
    ModalState["SUCCESS"] = "success";
    ModalState["WARNING"] = "warning";
})(ModalState || (ModalState = {}));
export const COOKIE_KEYS = [
    COOKIE_CART_ID_KEY,
    COOKIE_ORDER_NUMBER_KEY,
    PAYMENT_LINK_PROVIDER,
];
